import { useState, useEffect, useRef } from "react";
import useWindowDrag from "./use_window_drag";
import styles from "./styles.module.css";
import { trackEvent } from "./track_event";

export default MsnMessenger;

type Status = "online" | "busy" | "away" | "offline";

interface Contact {
   id: string;
   nickname: string;
   personalMessage: string;
   status: Status;
   greeting: string;
   replies: string[];
}

interface ChatMessage {
   sender: string;
   text: string;
}

const contacts: Contact[] = [
   { id: "ted", nickname: "Ted [c=4]BRB[/c]", personalMessage: "going into the cave", status: "online", greeting: "do you hear the sounds too??", replies: ["the new passage is tighter than yesterday", "did you move the rock?", "i didnt bring a flashlight today", "i wrote your name on the wall. i dont know why", "I can smell death"] },
   { id: "sandra", nickname: "~*~ SaNdRa ~*~ (L)", personalMessage: "has anyone borrowed my blue sweater??", status: "online", greeting: "were you at the gas station last night", replies: ["someone who looked like you was standing by the car wash", "he was wearing your jacket", "he bought a hot dog and looked straight at me", "forget it", "hes standing there now too"] },
   { id: "alan", nickname: "xX satan Xx", personalMessage: "ilu flugelhorn", status: "online", greeting: "yo got a croquette for u", replies: ["with mayo", "open wide", "its for ur own good", "relax ur pelvic floor", "extra mayo"] },
   { id: "hinata", nickname: "☆ hInAtA ☆ ^^", personalMessage: "sunday", status: "online", greeting: "its sunday here again. is it sunday where you are too?", replies: ["toonami all day", "dad made onigiri", "i ate 14", "lapskaus mukbang tonight"] },
   { id: "pat", nickname: "¤ Pat ¤", personalMessage: "omw to heaven", status: "online", greeting: "i have a letter for you from 2003", replies: ["its written in your handwriting", "should i read it out loud", "it just says 'do not open'", "i opened it", "its a photo of your house. taken from the inside"] },
   { id: "steffen", nickname: "†steffen k.†", personalMessage: "writing. billys in the oven", status: "online", greeting: "wrote x pages.", replies: ["i eat billy pan pizza", "madonnas favourtie snack u agrre?", "brbr powdering my noise", "So whats up.", "Ok cool, powdering my nose again.", "did you borrow my eternal darkness game?", "I mean gamecube?"] },
   { id: "donny", nickname: "(¯`·._.·[ donny ]·._.·´¯)", personalMessage: "wet @ metz game", status: "online", greeting: "yo", replies: ["im at the game", "Buzz is here", "he brought dvd's, hd ready", "we watching Dracula 3000", "battery died", "anyway what u doing", "can you bring more blue ray or hddvd's"] },
   { id: "frank", nickname: ":: Frank ::", personalMessage: "wingnuts, ur nuts", status: "online", greeting: "you forgot your change", replies: ["it was in 1998", "i put it in an envelope", "its behind the counter", "the store never closes", "i havent gone home since"] },
   { id: "virginia", nickname: "~ virginia ~ (8)", personalMessage: "the lagoon", status: "busy", greeting: "the water is so still i can see your room", replies: ["you moved your bed", "there is a new poster", "where you wet your bed", "who is that sleeping there", "now its turning over"] },
   { id: "jerry", nickname: "J3rRy H", personalMessage: "my goshness", status: "busy", greeting: "who left a tv dinner on my doorstep", replies: ["its still warm", "my name is on the lid", "meatballs", "i live alone"] },
   { id: "micheline", nickname: "*micheline* ♪", personalMessage: "DJ Dijon", status: "busy", greeting: "i have mustard on all my fingers and cant type properly", replies: ["sorr", "dijon", "dont ask why", "theres more in the cupboard", "the cupboard is full"] },
   { id: "robin", nickname: "rObIn (H)", personalMessage: "MickyMice 4 ever", status: "away", greeting: "the lot is empty again. only your car is here", replies: ["the engine is running", "someones sitting in the back seat smoking a fat cigar", "tom and jerry is on the radio", "come get it"] },
   { id: "samara", nickname: "†samara†", personalMessage: "7", status: "away", greeting: "have you seen the tape?", replies: ["ding dong", "honky tong", "bing bong", "ding dong honky tong, bing bong,", "bong"] },
   { id: "duchess", nickname: "♥ duchess ♥", personalMessage: "", status: "away", greeting: "you can come up now. shes gone to bed", replies: ["take your shoes off", "dont touch the piano", "ibsen rips bukser"] },
   { id: "lawson", nickname: "melonpan ^_^", personalMessage: "konbini 24h", status: "away", greeting: "the cashier asked about you again", replies: ["she knows your name", "i didnt say anything", "she had a photo", "you're dressed as a clown", "you never smile"] },
   { id: "muldvarpen", nickname: "xXx Muldvarpen xXx", personalMessage: "", status: "offline", greeting: "", replies: [] },
   { id: "tom", nickname: "tom :: lol ::", personalMessage: "", status: "offline", greeting: "", replies: [] },
   { id: "alice", nickname: "~alice~", personalMessage: "@ Lake Minnetonky", status: "offline", greeting: "", replies: [] },
   { id: "jack", nickname: "JaCk", personalMessage: "", status: "offline", greeting: "", replies: [] },
];


const statusLabelForStatus: Record<Status, string> = {
   online: "Online",
   busy: "Busy",
   away: "Away",
   offline: "Offline",
};

const statusClassForStatus: Record<Status, string> = {
   online: styles.messengerStatusOnline,
   busy: styles.messengerStatusBusy,
   away: styles.messengerStatusAway,
   offline: styles.messengerStatusOffline,
};

function MsnMessenger({ onClose }: { onClose: () => void }) {
   const [contactIdChatting, setContactIdChatting] = useState<string | null>(null);
   const [messagesForContactId, setMessagesForContactId] = useState<Record<string, ChatMessage[]>>({});
   const [draftMessage, setDraftMessage] = useState("");
   const [contactIdTyping, setContactIdTyping] = useState<string | null>(null);
   const [isShaking, setIsShaking] = useState(false);
   const conversationEndRef = useRef<HTMLDivElement | null>(null);
   const repliesSentForContactId = useRef<Record<string, number>>({});
   const { dragStyle, onTitleBarPointerDown } = useWindowDrag();

   const onlineContacts = contacts.filter(contact => contact.status !== "offline");
   const offlineContacts = contacts.filter(contact => contact.status === "offline");
   const contactChatting = contacts.find(contact => contact.id === contactIdChatting);

   useEffect(() => {
      conversationEndRef.current?.scrollIntoView();
   }, [messagesForContactId, contactIdTyping]);

   function openChat(contact: Contact) {
      setContactIdChatting(contact.id);
      if (messagesForContactId[contact.id]) return;
      trackEvent(`msn chat: ${contact.nickname}`);

      if (contact.status === "offline") {
         setMessagesForContactId({ ...messagesForContactId, [contact.id]: [] });
      } else {
         setMessagesForContactId({ ...messagesForContactId, [contact.id]: [{ sender: contact.nickname, text: contact.greeting }] });
      }
   }

   function addMessage(contactId: string, message: ChatMessage) {
      setMessagesForContactId(previous => ({ ...previous, [contactId]: [...(previous[contactId] ?? []), message] }));
   }

   function sendMessage() {
      if (!contactChatting) return;
      if (draftMessage.trim() === "") return;

      addMessage(contactChatting.id, { sender: "MSN Angel", text: draftMessage });
      trackEvent(`msn message sent: ${contactChatting.nickname}`);
      setDraftMessage("");
      replyLater(contactChatting);
   }

   function sendNudge() {
      if (!contactChatting) return;
      trackEvent(`msn nudge sent: ${contactChatting.nickname}`);

      setIsShaking(true);
      setTimeout(() => setIsShaking(false), 500);
      addMessage(contactChatting.id, { sender: "", text: "You have just sent a nudge." });
      replyLater(contactChatting);
   }

   function replyLater(contact: Contact) {
      const replyIndex = repliesSentForContactId.current[contact.id] ?? 0;
      const reply = contact.replies[replyIndex];
      if (reply === undefined) return;

      repliesSentForContactId.current[contact.id] = replyIndex + 1;
      setContactIdTyping(contact.id);
      setTimeout(() => {
         addMessage(contact.id, { sender: contact.nickname, text: reply });
         setContactIdTyping(null);
      }, 1500);
   }

   function renderContact(contact: Contact) {
      return (
         <div key={contact.id} className={styles.messengerContact} onClick={() => openChat(contact)}>
            <span className={statusClassForStatus[contact.status]} title={statusLabelForStatus[contact.status]} />
            <span className={styles.messengerNickname}>{contact.nickname}</span>
            {contact.personalMessage && <span className={styles.messengerPersonalMessage}>{contact.personalMessage}</span>}
         </div>
      );
   }

   function renderContactList() {
      return (
         <div className={styles.messengerContactList}>
            <div className={styles.messengerGroup}>▾ Online ({onlineContacts.length})</div>
            {onlineContacts.map(renderContact)}
            <div className={styles.messengerGroup}>▾ Offline ({offlineContacts.length})</div>
            {offlineContacts.map(renderContact)}
         </div>
      );
   }

   function renderConversation(contact: Contact) {
      const messages = messagesForContactId[contact.id] ?? [];

      return (
         <div className={styles.messengerConversation}>
            <div className={styles.messengerConversationHeader}>
               <span className={styles.messengerBack} onClick={() => setContactIdChatting(null)}>◄ Back</span>
               <span>To: <b>{contact.nickname}</b></span>
            </div>
            <div className={styles.messengerMessages}>
               {contact.status === "offline" && (
                  <div className={styles.messengerSystemMessage}>{contact.nickname} appears to be offline. Messages you send will be delivered when they sign in.</div>
               )}
               {messages.map((message, index) => (
                  message.sender === ""
                     ? <div key={index} className={styles.messengerSystemMessage}>{message.text}</div>
                     : <div key={index} className={styles.messengerMessage}>
                          <div className={styles.messengerMessageSender}>{message.sender} says:</div>
                          <div className={styles.messengerMessageText}>{message.text}</div>
                       </div>
               ))}
               <div ref={conversationEndRef} />
            </div>
            <div className={styles.messengerTypingLine}>
               {contactIdTyping === contact.id ? `${contact.nickname} is typing a message...` : ""}
            </div>
            <div className={styles.messengerInputRow}>
               <input
                  className={styles.messengerInput}
                  value={draftMessage}
                  onChange={(event) => setDraftMessage(event.target.value)}
                  onKeyDown={(event) => { if (event.key === "Enter") sendMessage(); }}
                  placeholder="Type a message..."
               />
               <span className={styles.messengerButton} onClick={sendMessage}>Send</span>
               <span className={styles.messengerButton} onClick={sendNudge}>Nudge</span>
            </div>
         </div>
      );
   }

   return (
      <div className={styles.messengerWindow}>
         <div className={isShaking ? styles.messengerShaking : styles.messenger} style={dragStyle}>
            <div className={styles.messengerTitleBar} onPointerDown={onTitleBarPointerDown}>
               <span>MSN</span>
               <span className={styles.messengerClose} onClick={onClose}>✕</span>
            </div>
            <div className={styles.messengerProfile}>
               <div className={styles.messengerAvatar}>😇</div>
               <div>
                  <div className={styles.messengerProfileName}>MSN Angel <span className={styles.messengerProfileStatus}>(Online)</span></div>
                  <div className={styles.messengerProfileMessage}>back from the mall</div>
               </div>
            </div>
            {contactChatting ? renderConversation(contactChatting) : renderContactList()}
         </div>
      </div>
   );
}
